module.exports = __webpack_public_path__ + "img/YouTube.1379c51.svg";